import { Directive, Input, ElementRef } from '@angular/core';

@Directive({
    selector: '[blockUi]',
    standalone: false
})
export class BlockUiSharedDirective {
  @Input() set blockUi(rules: {blocked: boolean, iconClass?: string}[]) {
	  let isBLocked = false;
	  for (const rule of rules) {
	    if (rule.blocked) {
		    isBLocked = true;
	      this.el.nativeElement.classList.add(rule.iconClass || 'permission');
	    } else {
	      this.el.nativeElement.classList.remove(rule.iconClass || 'permission');
	    }
		}
	  if (isBLocked) {
		  this.el.nativeElement.classList.add('block-ui');
	  } else {
		  this.el.nativeElement.classList.remove('block-ui');
	  }
  }
  
  constructor(private el: ElementRef) {
  }
}